<div class="member-container">
  <div class="member-sidebar">
    <button
      mat-button
      class="btn-tab"
      routerLink="/healthcheck/member/mybooking"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <div class="btn-tab-block">
        <div class="btn-tab-icon">
          <img
            ngSrc="assets/img/i-member-calendar.svg"
            width="24"
            height="24"
            alt=""
          />
        </div>
        <span>{{ 'member.my-reservation' | translate }}</span>
      </div>
    </button>
    
    <!-- 健調表按鈕：只有在 myReservation 載入完成且有預約資料時才顯示 -->
    <!-- <button
      *ngIf="isMyReservationLoaded && hasValidReservation()"
      mat-button
      class="btn-tab"
      routerLink="/healthcheck/member/form"
      routerLinkActive="active"
    >
      <div class="btn-tab-health">
        <div class="btn-tab-block">
          <div class="btn-tab-icon">
            <img
              ngSrc="assets/img/i-member-book.svg"
              width="24"
              height="24"
              alt=""
            />
          </div>
          <span>{{ 'member.health-questionnaire' | translate }}</span>
        </div>
        <span
          *ngIf="showUnfinishedTag && questionnaireStatus === 'AVAILABLE'"
          class="btn-tab-tag">
          {{ 'member.unfinished' | translate }}
        </span>
      </div>
    </button> -->

    <!-- 載入中狀態：當 myReservation 還沒載入完成時顯示 -->
    <!-- <div
      *ngIf="!isMyReservationLoaded"
      class="btn-tab loading-placeholder"
    >
      <div class="btn-tab-health">
        <div class="btn-tab-block">
          <div class="btn-tab-icon">
            <img
              ngSrc="assets/img/i-member-book.svg"
              width="24"
              height="24"
              alt=""
              style="opacity: 0.5;"
            />
          </div>
          <span style="opacity: 0.5;">{{ 'member.health-questionnaire' | translate }}</span>
        </div>
      </div>
    </div> -->
    
    <!-- <button
      mat-button
      class="btn-tab"
      routerLink="/healthcheck/member/report"
      routerLinkActive="active"
    >
      <div class="btn-tab-block">
        <div class="btn-tab-icon">
          <img
            ngSrc="assets/img/i-member-look.svg"
            width="24"
            height="24"
            alt=""
          />
        </div>
        <span>{{ 'member.query-exam-report' | translate }}</span>
      </div>
    </button> -->
    
    <button
      mat-button
      class="btn-tab"
      routerLink="/healthcheck/member/editprofile"
      routerLinkActive="active"
    >
      <div class="btn-tab-block">
        <div class="btn-tab-icon">
          <img
            ngSrc="assets/img/i-member-edit.svg"
            width="24"
            height="24"
            alt=""
          />
        </div>
        <span>{{ 'member.modify-basic-info' | translate }}</span>
      </div>
    </button>
    
    <mat-form-field appearance="fill" class="member-sidebar-mobile">
      <mat-select
        [(value)]="selectedRoute"
        (selectionChange)="onRouteChange($event.value)"
        placeholder="請選擇項目"
      >
        <mat-select-trigger>
          <span class="select-trigger-content">
            <span>{{ getSelectedLabel() }}</span>
            <label *ngIf="getSelectedStatus()" class="btn-tab-tag">{{ getSelectedStatus() }}</label>
          </span>
        </mat-select-trigger>
        <mat-option *ngFor="let option of options" [value]="option.route">
          {{ option.label }}
          <span *ngIf="option.status">
            <label class="btn-tab-tag">{{ option.status }}</label>
          </span>
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  
  <div class="page-container">
    <router-outlet></router-outlet>
  </div>
</div>